<template>
  <b-container class="mt-5 mb-5" fluid>
    <b-overlay :show="submitting" rounded="sm">
      <b-row>
        <b-col>
          <h4>Password reset request</h4>
          <p>Please enter the email used to log in.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="!complete">
          <b-form
            @submit.stop.prevent
            :validated="submitted"
            novalidate
            ref="frm"
          >
            <b-form-group :invalid-feedback="stat.email">
              <label v-if="userEmail.email.length !== 0">email:</label>
              <b-input
                type="email"
                v-model="userEmail.email"
                placeholder="yourname@domain.com"
                required
                ref="em"
                @blur="test"
              />
            </b-form-group>
          </b-form>
          <b-row>
            <b-col class="d-flex justify-content-end">
              <b-button variant="blue" class="action-button" @click="onSubmit">
                Request reset
              </b-button>
            </b-col>
            <b-col>
              <b-button variant="orange" class="action-button" to="/">
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-else>
          <p style="color:green">
            Your password reset request, has been submitted, please check your
            email for further instrcutions.
          </p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      stat: {
        email: ""
      },
      userEmail: {
        email: ""
      },
      submitted: false,
      complete: false,
      submitting: false
    };
  },
  methods: {
    onSubmit() {
      debugger;
      this.submitted = true;
      if (!this.$refs.frm.checkValidity()) {
        this.stat["email"] = this.$refs.em.validationMessage;
      }
      debugger;
      this.submitting = true;
      return this.$store.dispatch("user/forgotPass", this.userEmail).then(r => {
        debugger;
        this.complete = r;
        this.submitting = false;
        return;
      });
    },
    test(e) {
      debugger;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ForgotPassword.vue